;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import apibaseurl from 'shared/utils/apiBaseUrl';

const addApiBaseUrl = (path: string): string =>
  path.indexOf('https://') === -1 && path.indexOf('http://') === -1 ? `${apibaseurl}/${path}` : path;

export default addApiBaseUrl;
